import React, { useState } from 'react';
import { Row, Col, Card, Table, Badge, Form, InputGroup, Button } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';

const DetalleRutas = ({ resumenDiario, formatearMonto, formatearPorcentaje }) => {
  const [filtroRuta, setFiltroRuta] = useState('');
  const [filtroRegion, setFiltroRegion] = useState('');
  const [filtroEmpresa, setFiltroEmpresa] = useState('');
  const [filtroTMS, setFiltroTMS] = useState('');

  // Obtener todas las rutas de todos los conductores
  const obtenerTodasLasRutas = () => {
    if (!resumenDiario?.detalle_conductores) return [];
    
    const rutasCompletas = [];
    resumenDiario.detalle_conductores.forEach(conductor => {
      conductor.rutas.forEach(ruta => {
        rutasCompletas.push({
          ...ruta,
          conductorInfo: conductor.conductor,
          empresaInfo: conductor.empresa
        });
      });
    });
    
    return rutasCompletas.sort((a, b) => a.ruta.localeCompare(b.ruta));
  };

  const todasLasRutas = obtenerTodasLasRutas();

  // Filtrar rutas
  const rutasFiltradas = todasLasRutas.filter(ruta => {
    const cumpleFiltroRuta = !filtroRuta || (ruta.ruta && ruta.ruta.toLowerCase().includes(filtroRuta.toLowerCase()));
    const cumpleFiltroRegion = !filtroRegion || (ruta.region && ruta.region.toLowerCase().includes(filtroRegion.toLowerCase()));
    const cumpleFiltroEmpresa = !filtroEmpresa || (ruta.empresaInfo?.sigla && ruta.empresaInfo.sigla.toLowerCase().includes(filtroEmpresa.toLowerCase()));
    const cumpleFiltroTMS = !filtroTMS || (ruta.tms && ruta.tms.toLowerCase().includes(filtroTMS.toLowerCase()));
    
    return cumpleFiltroRuta && cumpleFiltroRegion && cumpleFiltroEmpresa && cumpleFiltroTMS;
  });

  // Obtener valores únicos para filtros
  const regionesUnicas = [...new Set(todasLasRutas.map(ruta => ruta.region).filter(Boolean))].sort();
  const empresasUnicas = [...new Set(todasLasRutas.map(ruta => ruta.empresaInfo?.sigla).filter(Boolean))].sort();
  const tmsUnicos = [...new Set(todasLasRutas.map(ruta => ruta.tms).filter(Boolean))].sort();

  // Función para obtener color de empresa
  const obtenerColorEmpresa = (sigla) => {
    const colores = {
      'SPR': 'warning'
    };
    return colores[sigla] || 'dark';
  };

  // Función para obtener color de TMS
  const obtenerColorTMS = (tms) => {
    const colores = {
      'DispatchTrack': 'success',
      'GeoSort': 'primary',
      'Manual': 'warning'
    };
    return colores[tms] || 'secondary';
  };

  const limpiarFiltros = () => {
    setFiltroRuta('');
    setFiltroRegion('');
    setFiltroEmpresa('');
    setFiltroTMS('');
  };

  if (todasLasRutas.length === 0) {
    return (
      <div className="text-center p-5">
        <FaIcons.FaInbox style={{ fontSize: '3rem', color: '#dee2e6', marginBottom: '16px' }} />
        <h6 style={{ color: '#6c757d' }}>No hay rutas para la fecha seleccionada</h6>
      </div>
    );
  }

  return (
    <>
      {/* Header y Filtros */}
      <Row className="mb-4">
        <Col xs={12}>
          <Card className="shadow-sm border-0">
            <Card.Header className="bg-light border-0">
              <Row className="align-items-center">
                <Col>
                  <h6 className="mb-0">
                    <FaIcons.FaList className="me-2" style={{ color: '#1976d2' }} />
                    Detalle de Rutas ({rutasFiltradas.length} de {todasLasRutas.length} rutas)
                  </h6>
                </Col>
                <Col xs="auto">
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={limpiarFiltros}
                    disabled={!filtroRuta && !filtroRegion && !filtroEmpresa && !filtroTMS}
                  >
                    <FaIcons.FaEraser className="me-1" />
                    Limpiar Filtros
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col xs={12} md={3} className="mb-3">
                  <Form.Group>
                    <Form.Label>Buscar por Ruta</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FaIcons.FaSearch />
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        placeholder="Ingrese número de ruta..."
                        value={filtroRuta}
                        onChange={(e) => setFiltroRuta(e.target.value)}
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
                
                <Col xs={12} md={3} className="mb-3">
                  <Form.Group>
                    <Form.Label>Filtrar por Región</Form.Label>
                    <Form.Select
                      value={filtroRegion}
                      onChange={(e) => setFiltroRegion(e.target.value)}
                    >
                      <option value="">Todas las regiones</option>
                      {regionesUnicas.map(region => (
                        <option key={region} value={region}>{region}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xs={12} md={3} className="mb-3">
                  <Form.Group>
                    <Form.Label>Filtrar por Empresa</Form.Label>
                    <Form.Select
                      value={filtroEmpresa}
                      onChange={(e) => setFiltroEmpresa(e.target.value)}
                    >
                      <option value="">Todas las empresas</option>
                      {empresasUnicas.map(empresa => (
                        <option key={empresa} value={empresa}>{empresa}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xs={12} md={3} className="mb-3">
                  <Form.Group>
                    <Form.Label>Filtrar por TMS</Form.Label>
                    <Form.Select
                      value={filtroTMS}
                      onChange={(e) => setFiltroTMS(e.target.value)}
                    >
                      <option value="">Todos los TMS</option>
                      {tmsUnicos.map(tms => (
                        <option key={tms} value={tms}>{tms}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Estadísticas Rápidas */}
      <Row className="mb-4">
        <Col xs={12} sm={6} md={3} className="mb-3">
          <Card className="border-0 bg-primary text-white">
            <Card.Body className="text-center py-3">
              <h5 className="mb-1">{rutasFiltradas.length}</h5>
              <small>Rutas Mostradas</small>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} sm={6} md={3} className="mb-3">
          <Card className="border-0 bg-info text-white">
            <Card.Body className="text-center py-3">
              <h5 className="mb-1">
                {rutasFiltradas.reduce((sum, ruta) => sum + (ruta.total_guias || 0), 0)}
              </h5>
              <small>Guías Totales</small>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} sm={6} md={3} className="mb-3">
          <Card className="border-0 bg-success text-white">
            <Card.Body className="text-center py-3">
              <h5 className="mb-1">
                {rutasFiltradas.reduce((sum, ruta) => sum + (ruta.guias_entregadas || 0), 0)}
              </h5>
              <small>Guías Entregadas</small>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} sm={6} md={3} className="mb-3">
          <Card className="border-0 bg-warning text-white">
            <Card.Body className="text-center py-3">
              <h5 className="mb-1">
                {formatearPorcentaje(
                  rutasFiltradas.length > 0 
                    ? (rutasFiltradas.reduce((sum, ruta) => sum + (ruta.guias_entregadas || 0), 0) / 
                       rutasFiltradas.reduce((sum, ruta) => sum + (ruta.total_guias || 0), 0)) * 100
                    : 0
                )}
              </h5>
              <small>NS Promedio</small>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Tabla de Rutas */}
      <Row>
        <Col xs={12}>
          <Card className="shadow-sm border-0">
            <Card.Body className="p-0">
              <div className="table-responsive">
                <Table className="mb-0" hover size="sm">
                  <thead className="table-light sticky-top">
                    <tr>
                      <th className="fw-bold">Ruta</th>
                      <th className="fw-bold">Región</th>
                      <th className="fw-bold text-center">Guías Totales</th>
                      <th className="fw-bold text-center">Guías Entregadas</th>
                      <th className="fw-bold text-center">NS (%)</th>
                      <th className="fw-bold text-center">Puntos Entrega</th>
                      <th className="fw-bold text-center">Puntos Exitosos</th>
                      <th className="fw-bold text-center">NS Consolidado (%)</th>
                      <th className="fw-bold text-end">Precio Ruta</th>
                      <th className="fw-bold">Conductor</th>
                      <th className="fw-bold text-center">Empresa</th>
                      <th className="fw-bold text-center">TMS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rutasFiltradas.map((ruta, index) => (
                      <tr key={`${ruta.ruta_id}-${index}`}>
                        <td>
                          <strong style={{ color: '#495057' }}>{ruta.ruta || 'N/A'}</strong>
                        </td>
                        <td>
                          <small className="text-muted">{ruta.region || 'N/A'}</small>
                        </td>
                        <td className="text-center">
                          <Badge bg="info" className="px-2">
                            {ruta.total_guias || 0}
                          </Badge>
                        </td>
                        <td className="text-center">
                          <Badge bg="success" className="px-2">
                            {ruta.guias_entregadas || 0}
                          </Badge>
                        </td>
                        <td className="text-center">
                          <Badge 
                            bg={(ruta.ns || 0) >= 95 ? 'success' : 
                                (ruta.ns || 0) >= 85 ? 'warning' : 'danger'}
                            className="px-2"
                          >
                            {formatearPorcentaje(ruta.ns)}
                          </Badge>
                        </td>
                        <td className="text-center">
                          <small className="text-muted">{ruta.puntos_entrega_total || 0}</small>
                        </td>
                        <td className="text-center">
                          <small className="text-success">{ruta.puntos_entrega_exitosos || 0}</small>
                        </td>
                        <td className="text-center">
                          <Badge 
                            bg={(ruta.ns_consolidado || 0) >= 95 ? 'success' : 
                                (ruta.ns_consolidado || 0) >= 85 ? 'warning' : 'danger'}
                            className="px-2"
                          >
                            {formatearPorcentaje(ruta.ns_consolidado)}
                          </Badge>
                        </td>
                        <td className="text-end">
                          <strong style={{ color: '#28a745' }}>
                            {formatearMonto(ruta.precio_ruta_egreso)}
                          </strong>
                        </td>
                        <td>
                          <div style={{ fontSize: '0.9rem' }}>
                            <div className="fw-bold">{ruta.conductorInfo?.usuarioSpread}</div>
                            {/* <div className="fw-bold">{ruta.conductorInfo?.nombre} {ruta.conductorInfo?.apellido}</div> */}
                            {/* <small className="text-muted">{ruta.conductorInfo?.usuarioSpread || 'N/A'}</small> */}
                          </div>
                        </td>
                        <td className="text-center">
                          <Badge bg={obtenerColorEmpresa(ruta.empresaInfo?.sigla)} className="fw-bold">
                            {ruta.empresaInfo?.sigla || 'N/A'}
                          </Badge>
                        </td>
                        <td className="text-center">
                          <Badge bg={obtenerColorTMS(ruta.tms)} className="fw-bold text-white">
                            {ruta.tms || 'N/A'}
                          </Badge>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
              
              {rutasFiltradas.length === 0 && (filtroRuta || filtroRegion || filtroEmpresa || filtroTMS) && (
                <div className="text-center p-4">
                  <FaIcons.FaSearch style={{ fontSize: '2rem', color: '#dee2e6', marginBottom: '12px' }} />
                  <h6 style={{ color: '#6c757d' }}>No se encontraron rutas con los filtros aplicados</h6>
                  <Button variant="link" onClick={limpiarFiltros}>
                    Limpiar filtros
                  </Button>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default DetalleRutas;
